import React from 'react';

import Label from './Label';
import Value from './Value';

const Info = ({ label, children }) => (
  <div>
    <Label>{label}</Label>
    <Value>{children}</Value>
  </div>
);

export default Info;
